// frontend/src/actions/cartActions.js - Clean version without discounts

import {
    addCartItemRequest,
    addCartItemSuccess,
    updateCartItems,
    getCartItemKey
} from "../slices/cartSlice";
import axios from 'axios';

const addCartItem = (id, quantity, selectedWeight) => async (dispatch) => {
    try {
        dispatch(addCartItemRequest());
        
        // Get product details from API
        const { data } = await axios.get(`/api/v1/product/${id}`);
        console.log('Product data received:', data);
        
        // Determine price based on product type (no discounts)
        let price = data.product.price;
        
        if (data.product.priceType === 'fixed') {
            const weightOption = data.product.weightOptions.find(opt => opt.weight === selectedWeight);
            if (weightOption) {
                price = weightOption.price;
            }
        } else if (data.product.priceType === 'perDozen') {
            // Use dozenPrice for egg products
            price = data.product.dozenPrice || data.product.price;
        } else if (data.product.priceType === 'perPack') {
            // Use packPrice for pack products
            price = data.product.packPrice || data.product.price;
        }
        
        // Create cart item with clean pricing (no discounts)
        const cartItem = {
            product: data.product._id,
            name: data.product.name,
            price: price,
            image: data.product.images[0].image,
            quantity: quantity,
            priceType: data.product.priceType,
            selectedWeight: selectedWeight,
            weightOptions: data.product.weightOptions || [],
            finalPrice: price * quantity,
            category: data.product.category,
            // For egg products, include the dozen price
            dozenPrice: data.product.priceType === 'perDozen' ? (data.product.dozenPrice || data.product.price) : 0,
            // For pack products, include the pack price
            packPrice: data.product.priceType === 'perPack' ? (data.product.packPrice || data.product.price) : 0
        };
        
        console.log('Adding item to cart with data:', cartItem);
        dispatch(addCartItemSuccess(cartItem));
        
        // Redux + localStorage are synced by cartSlice; no need to manually update localStorage here
    } catch (error) {
        console.error('Failed to add item to cart:', error);
    }
};

// Simple price calculation without discounts
const calculateItemPrice = (item) => {
    if (item.priceType === 'perDozen') {
        return item.dozenPrice || item.price;
    } else if (item.priceType === 'perPack') {
        return item.packPrice || item.price;
    }
    return item.price;
};

const recalculateCartPrices = (items) => {
    return items.map(item => {
        const itemPrice = calculateItemPrice(item);
        
        return {
            ...item,
            finalPrice: itemPrice * item.quantity
        };
    });
};

// Export clean functions without discount functionality
export {
    addCartItem,
    recalculateCartPrices,
    calculateItemPrice
};